import { has } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refFishingToolType"].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { forceDisableEditFishingTool } = props;
                return {
                    disabled: forceDisableEditFishingTool
                };
            }
        },
        {
            check: ({ field }) => {
                return ["refFishingTool"].includes(field?.key);
            },
            inputPropField: ({ modelRef, props }) => {
                const { forceDisableEditFishingTool } = props;
                return {
                    disabled: !modelRef.refFishingToolType || forceDisableEditFishingTool
                };
            }
        },
        {
            check: ({ field }) => {
                return ["fishingToolName"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return  modelRef.refFishingTool?.isSelfNamingToolName == true
            }
        },
        {
            check: ({ field }) => {
                return ["qty"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refFishingTool?.isRequireInputQty == true;
            },
            inputPropField: ({ modelRef }) => {
                return {
                    disabled: modelRef.refFishingTool?.isSubQty == true
                };
            }
        },
        {
            check: ({ field }) => {
                return ["refUnitType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return  modelRef.refFishingTool?.isRequireInputQty == true;
            },
            inputPropField: () => {
                return {
                    disabled: true
                };
            }
        },
        {
            check: ({ field }) => {
                return ["firstSubQty", "secondSubQty"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                const checkVisible = modelRef.refFishingTool?.isRequireInputQty
                    && modelRef.refFishingTool?.isSubQty  == true;
                return checkVisible || false
            }
        },
        {
            check: ({ field }) => {
                return ["exampleImage"].includes(field?.key);
            },
            visibleField: ({ modelRef, props }) => {
                const { hiddenPreviewButton } = props;
                const checkVisible = modelRef?.refFishingTool?.path != null && !hiddenPreviewButton
                return checkVisible || false
            }
        },
        {
            check: ({ field }) => {
                return  ["width", "refWidthType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refFishingTool?.isRequireInputWidth == true;
            }
        },
    ];
};
